module.exports = __webpack_public_path__ + "img/Ministry_Update_Mobile.jpg";